export default __webpack_public_path__ + "static/media/ic_office_365.af90a0cb.svg";